const overlapTargets = document.querySelectorAll('.js-scroll-overlap');

function setOverlapDisabled(disabled) {
  overlapTargets.forEach((el) => {
    el.classList.toggle('is-disabled', disabled);
  });
}

scrollOverlap();
initStableAnchor();

function scrollOverlap() {
  if (overlapTargets.length === 0) return;

  let lastWinHeight = window.innerHeight;
  let ticking = false;
  let isScrolling = false;
  let scrollTimer = null;
  const offsetCache = new WeakMap();

  const setStickyOffset = () => {
    if (ticking || isScrolling) return;

    ticking = true;

    requestAnimationFrame(() => {
      const winH = lastWinHeight;

      overlapTargets.forEach((target) => {
        const diff = target.offsetHeight - winH;
        const offsetValue = diff > 0 ? `-${diff}px` : '-1px';

        if (offsetCache.get(target) !== offsetValue) {
          offsetCache.set(target, offsetValue);
          target.style.setProperty('--sticky-offset', offsetValue);
        }
      });

      ticking = false;
    });
  };

  setStickyOffset();

  window.addEventListener('resize', () => {
    const winH = window.innerHeight;
    if (lastWinHeight !== winH) {
      lastWinHeight = winH;
      setStickyOffset();
    }
  });

  const resizeObserver = new ResizeObserver(() => {
    if (!isScrolling) setStickyOffset();
  });

  overlapTargets.forEach((target) => {
    resizeObserver.observe(target);
  });

  window.addEventListener('scroll', () => {
    isScrolling = true;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      isScrolling = false;
      setStickyOffset();
    }, 150);
  }, { passive: true });

  let isKeyboardFocus = false;

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
      isKeyboardFocus = true;
      setOverlapDisabled(true);
    }
  });

  document.addEventListener('mousedown', () => {
    if (isKeyboardFocus) {
      isKeyboardFocus = false;
      setOverlapDisabled(false);
    }
  });
}

function initStableAnchor() {
  const ANCHOR_OFFSET = 20;

  const getScrollTop = (el) => {
    return el.getBoundingClientRect().top + window.scrollY - ANCHOR_OFFSET;
  };

  const waitScrollEnd = (onDone) => {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      clearTimeout(fallbackTimer);
      onDone();
    };

    const fallbackTimer = setTimeout(finish, 900);
    window.addEventListener('scrollend', finish, { once: true });
  };

  const scrollTo = (target) => {
    if (!target) return;

    setOverlapDisabled(true);

    requestAnimationFrame(() => {
      const top = getScrollTop(target);
      window.scrollTo({ top, left: 0, behavior: 'smooth' });
      waitScrollEnd(() => setOverlapDisabled(false));
    });
  };

  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;

    const hash = a.getAttribute('href');
    if (!hash || hash === '#') return;

    const target = document.querySelector(hash);
    if (!target) return;

    e.preventDefault();
    scrollTo(target);
  });

  window.addEventListener('load', () => {
    if (window.location.hash) {
      scrollTo(document.querySelector(window.location.hash));
    }
  });
}
